module.exports = __webpack_public_path__ + "img/icon_map_penguan_lixian1.9b1c0fee.svg";